export default __webpack_public_path__ + "static/media/SeedFundSchemeLogo.797f866f.svg";